/**
 * Send event data to LiveSession, if the LiveSession `<script>` which sets `window.__ls()` is present.
 * Otherwise, do nothing. Documentation: https://developers.facebook.com/docs/meta-pixel/guides/track-multiple-events
 */
export function trackEventViaLiveSession (name, data) {
  if (typeof window.__ls === 'function') {
    try {
      window.__ls('track', name, data)
    } catch (e) {
      // eslint-disable-next-line no-undef
      Rollbar.error('Failed to track event via Livesession', e)
    }
  }
}

/**
 * Send event data to LiveSession, if the LiveSession `<script>` which sets `window.__ls()` is present.
 * Otherwise, do nothing. NOTE: LiveSession accepts only the following keys: `name`, `email`, `params`.
 * Documentation: https://developers.livesession.io/javascript-api/methods/#identify
 */
export function identifyUserViaLiveSession (userId, data) {
  if (typeof window.__ls === 'function') {
    try {
      const params = {
        name: userId ? `ID #${userId}` : null,
        params: {
          ...data,
          userId: userId || null
        }
      }
      window.__ls('identify', params)
    } catch (e) {
      // eslint-disable-next-line no-undef
      Rollbar.error('Failed to track event via Livesession', e)
    }
  }
}
